import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import YoutubeFormLayer from "../components/YoutubeFormLayer";

const YoutubeFormPage = () => {
    return (
        <MasterLayout>
            <YoutubeFormLayer />
        </MasterLayout>
    );
};

export default YoutubeFormPage;
